'use client';

import { useEffect } from 'react';
import { useCustomerly } from 'react-live-chat-customerly';

/**
 * Nasconde la bolla di Customerly finché il componente che lo chiama è montato
 * e la rimette al suo posto allo smontaggio. Serve ai pannelli che occupano
 * l'angolo in basso a destra (l'anteprima delle fonti): la chat copriva i
 * bottoni. Da usare in componenti montati solo da aperti, come i modal Radix
 * con `open` sempre vero.
 */
export function useHideCustomerlyWhileMounted() {
  const { hide, show } = useCustomerly();

  useEffect(() => {
    hide();
    return () => show();
  }, [hide, show]);
}
